import React from "react";
import styled from "styled-components";
import {CardWrapper, CardHeader, CardDescription, CardReadMoreWrapper} from "../Card/Card";
export const Icon = styled.i`
	color: ${({ theme }) => theme.colors.primary || theme.colors.black};
	font-size: 23px;
	&:before {
		margin: 0;
	}
`;

export const ArrowButton = ({ Name, Url, Description, ReadMoreHereText }) => {
	return (
		<CardWrapper padding="24px 20px">
			<CardHeader padding="0" fontSize="24px">
				{Name}
			</CardHeader>
			<CardDescription padding="8px 0 16px">
				{Description}
			</CardDescription>
			<CardReadMoreWrapper href={Url} fontSize="18px">
				{ReadMoreHereText}<Icon className="icon-right-arrow d-flex"></Icon>
			</CardReadMoreWrapper>
		</CardWrapper>
	);
};
